import React, { useEffect, useState } from "react";
import withAuthorization from "../Session/withAuthorization";
import { useHistory } from "react-router-dom";
import * as ROUTES from "../../constants/routes";

import { Grid, Container, Typography, makeStyles, Hidden } from "@material-ui/core";
import Lottie from "lottie-react";
import CountUp from "react-countup";

import { useTranslation } from "react-i18next";

import Logo from "../../assets/logo.png";

const CompletingProfile = (props) => {
  const { firebase } = props;
  const styles = useStyles();
  const history = useHistory();

  const [moreTimeIsNeeded, setMoreTimeIsNeeded] = useState(false);

  useEffect(() => {
    const timeOutID = setTimeout(() => {
      firebase.user(firebase.currentUser().uid).child("sgpfc").off("child_changed");
      history.push(ROUTES.ERROR);
    }, 45500); // 45 segundos hasta mostart el error

    const addMoreTime = setTimeout(() => {
      setMoreTimeIsNeeded(true);
    }, 15500); // cambiamos el texto para solicitar más tiempo

    const userRef = firebase.user(firebase.currentUser().uid).child("sgpfc");

    userRef.once("value").then((snap) => {
      const v = snap.val()?.isSuccessfullyCreated;
      if (v) {
        clearTimeout(timeOutID);
        clearTimeout(addMoreTime);
        setTimeout(() => {
          history.push(ROUTES.HOME);
        }, 4000);
      } else {
        userRef.on("child_changed", (snap) => {
          if (snap.key == "isSuccessfullyCreated" && snap.val()) {
            clearTimeout(timeOutID);
            clearTimeout(addMoreTime);
            setTimeout(() => {
              history.push(ROUTES.HOME);
            }, 4000);
          }
        });
      }
    });

    return () => {
      firebase.user(firebase.currentUser().uid).child("sgpfc").off("child_changed");
    };
  }, []);

  return <SettingUpComponent username={firebase.currentUser().displayName} moreTimeIsNeeded={moreTimeIsNeeded} />;
};

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(CompletingProfile);

const SettingUpComponent = ({ username, moreTimeIsNeeded }) => {
  const { t } = useTranslation();
  const styles = useStyles();

  return (
    <Grid container alignItems="center" style={{ minHeight: "90", paddingTop: 32 }}>
      <Container>
        <Hidden xsDown>
          <LgWindow username={username} moreTimeIsNeeded={moreTimeIsNeeded} />
        </Hidden>
        <Hidden smUp>
          <SmWindow username={username} moreTimeIsNeeded={moreTimeIsNeeded} />
        </Hidden>
      </Container>
      <Grid item xs={12} container style={{ position: "absolute", bottom: 19 }} justify="center">
        <Typography className={styles.mainSubtitle} style={{ marginBottom: 0 }}>
          {t("productOf")}{" "}
          <img
            style={{ width: 150, marginLeft: 6, marginBottom: -2, cursor: "pointer" }}
            src={Logo}
            onClick={() => window.open("https://www.bexencardio.com/es/", "_blank").focus()}
          />
        </Typography>
      </Grid>
    </Grid>
  );
};

const SmWindow = ({ username, moreTimeIsNeeded }) => {
  const { t } = useTranslation();
  const styles = useStyles();
  return (
    <Grid container justify="center" spacing={3}>
      <Grid item xs={12} md={8} lg={0} container justify="center">
        <Typography className={styles.mainTitle}>{t("Casi_lo_tenemos_", { name: !!username ? username : "" })}</Typography>
      </Grid>
      <Grid item xs={10} md={8} lg={5}>
        <Lottie animationData={require("../../assets/settingUpProfile.json")} autoPlay loop />
      </Grid>

      <Grid item xs={12} md={8} lg={4} container justify="center">
        <Typography className={styles.mainSubtitle}>{t(`Estamos_terminando_de_configurar_tu_cuenta,_el_proceso_puede_tardar_unos_segundos...`)}</Typography>
      </Grid>
      <Grid item xs={12} container justify="center">
        <Typography className={styles.countDown}>
          {!moreTimeIsNeeded ? (
            <CountUp start={15} end={0} duration={15} />
          ) : (
            <Typography variant="h4" style={{ textAlign: "center" }}>
              {t("Un_momento,_por_favor...")}
            </Typography>
          )}
        </Typography>
      </Grid>
    </Grid>
  );
};

const LgWindow = ({ username, moreTimeIsNeeded }) => {
  const { t } = useTranslation();
  const styles = useStyles();
  return (
    <Container>
      <Grid container justify="center" alignItems="center" spacing={3} style={{ minHeight: "90vh" }}>
        <Grid item sm={4} md={5} container justify="center">
          <Lottie animationData={require("../../assets/settingUpProfile.json")} autoPlay loop />
        </Grid>
        <Grid item sm={8} md={7}>
          <Grid item xs={12} container justify="center">
            <Typography className={styles.mainTitle}>{t("Casi_lo_tenemos_", { name: !!username ? username : "" })}</Typography>
          </Grid>

          <Grid container justify="center" className={styles.descriptionContainer}>
            <Grid item xs={12} md={7}>
              <Typography className={styles.mainSubtitle}>{t(`Estamos_terminando_de_configurar_tu_cuenta,_el_proceso_puede_tardar_unos_segundos...`)}</Typography>
            </Grid>
            <Grid item xs={12} container justify="center" className={styles.countDownContainer}>
              <Typography className={styles.countDown}>
                {!moreTimeIsNeeded ? (
                  <CountUp start={15} end={0} duration={15} />
                ) : (
                  <Typography variant="h4" style={{ textAlign: "center" }}>
                    {t("Un_momento,_por_favor...")}
                  </Typography>
                )}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

const useStyles = makeStyles((theme) => ({
  countDownContainer: {
    [theme.breakpoints.up("sm")]: {
      marginTop: 6,
    },
    [theme.breakpoints.up("md")]: {
      marginTop: 32,
    },
    [theme.breakpoints.up("lg")]: {
      marginTop: 64,
    },
  },
  descriptionContainer: {
    [theme.breakpoints.up("sm")]: {
      marginTop: 0,
    },
    [theme.breakpoints.up("md")]: {
      marginTop: 32,
    },
    [theme.breakpoints.up("lg")]: {
      marginTop: 64,
    },
  },
  mainTitle: {
    letterSpacing: 0,
    color: "#3c4043",
    marginBottom: theme.spacing(5),
    [theme.breakpoints.up("sm")]: {
      font: "400 40px/50px Google Sans,Arial,sans-serif",
      paddingRight: 25,
    },
    [theme.breakpoints.down("sm")]: {
      font: "400 30px/40px Google Sans,Arial,sans-serif",
    },
  },

  mainSubtitle: {
    animation: "fade-down .8s ease .3s 1 normal both running",
    color: "#9aa0a6",
    font: "400 16px/26px Google Sans,Arial,sans-serif",
    marginRight: 9,
  },

  countDown: {
    letterSpacing: 0,
    color: "#3c4043",

    [theme.breakpoints.up("sm")]: {
      marginTop: 9,
      font: "400 55px/65px Google Sans,Arial,sans-serif",
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: 19,
      font: "500 50px/60px Google Sans,Arial,sans-serif",
    },
  },
}));
